import Modal from "react-bootstrap/Modal";
import { styleEnd } from "../../algorithms/styleDirection";
import { objToFormData } from "../../algorithms";
import { addPost } from "./../../API/store/actions/discussion/discussion";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";
import { useFormik } from "formik";
import { formikSetup, validationSchema } from "../tasks/formikValidation";
import { getDir, getCurrentLangFromRedux } from "../../algorithms/styleChanges";
import { initialValues } from "./../tasks/formikValidation";
import Button from "../sharedComponents/buttons/button";
import TextInput from "../sharedComponents/inputs/textInput";
import TextArea from "../sharedComponents/textarea/textArea";
import FileInput from "../sharedComponents/inputs/fileInput";
import { useState } from "react";

const DisccusionForm = (props) => {
  const {
    onHide,
    communityId,
    userLogged,
    userToken,
    setProcAdded,
    procAdded,
  } = props;
  const [disable, setDisable] = useState(false);

  const submit = async (values) => {
    values.MemberId = parseInt(userLogged?.memberId);
    values.CommunityId = communityId;
    let data = objToFormData(values);
    if (disable) {
      return;
    } else {
      setDisable(true);
    }
    let res = await addPost(data, userToken);
    if (res.status <= 206) {
      setProcAdded(!procAdded);
      onHide();
      setDisable(false);
    } else {
      setDisable(false);
    }
  };
  const formik = useFormik(
    formikSetup(initialValues, undefined, validationSchema, "posts", submit)
  );
  const { values, handleChange, setFieldValue, touched, errors, handleSubmit } =
    formik;
  return (
    <Modal
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      {...props}
      style={{ zIndex: 1000000 }}
      backdrop="static"
    >
      <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex align-items-center">
            <div
              style={{
                backgroundColor: "white",
                height: 30,
                width: 30,
                borderRadius: "50%",
              }}
              className="d-flex justify-content-center text-center align-items-center px-1"
            >
              <img
                src="/assets/images/Group 8274.png"
                width={30}
                height={30}
                alt=""
              />
            </div>

            <div className="text-dark">
              <p
                className="my-0 mx-1"
                style={{
                  fontSize: 18,
                  textAlign: "justify",
                  color: "#1a73e8",
                }}
              >
                {Lang.addDiscuss}
              </p>
            </div>
          </div>
        </Modal.Title>
        <div className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}>
          <Icon
            name="times"
            size={22}
            color={"#1A73E8"}
            onclick={() => {
              onHide();
              setDisable(false);
            }}
          />
        </div>
      </Modal.Header>

      <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <form onSubmit={handleSubmit}>
          <div className="d-flex flex-column align-items-center">
            <div
              className="my-2"
              style={{ color: "#1A73E8", fontWeight: "bold" }}
            >
              اطرح قضية للنقاش
            </div>
            <TextInput
              name={"Title"}
              onChange={handleChange}
              type={"text"}
              containerStyle={"col-11 my-2"}
              hiddenPlaceholder={Lang.title + "*"}
            />
            <div className="col-11 position-relative">
              <TextArea
                rows={6}
                name={"Description"}
                onChange={handleChange}
                containerStyle={"col-12 my-2"}
                placeholder={Lang.Description + "*"}
              />
              <div style={{ position: "absolute", bottom: 15, right: 10 }}>
                <FileInput
                  name={"Attachment"}
                  onChange={(e) => {
                    setFieldValue("Attachment", e.target.files[0]);
                  }}
                  iconName={"paperclip"}
                  iconPrefix={"fas"}
                  size={15}
                  iconColor={values.Attachment ? "#1a73e8" : "#C7C7C9"}
                  backgroundSize={15}
                  backgroundColor={"white"}
                  fileName={values.Attachment.name ?? " "}
                  containerStyle={""}
                  accept={".gif, .jpg, .png, .doc, .pdf, .xlsx"}
                />
              </div>
            </div>
            <Button
              disable={disable}
              content={disable ? "جاري النشر" : "نشر"}
              type={"submit"}
              containerStyle={"my-3 col-2"}
              buttonStyleType="solid"
            />
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};
export default DisccusionForm;
